"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _ToastManager = require("./Toast/ToastManager");
var _Header = require("./Header");
var _useNavigation = require("./hooks/useNavigation");
var _useUserPreferences3 = require("./hooks/useUserPreferences");
var _utils = require("../common/utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PostLeave = function PostLeave() {
  var navigate = (0, _useNavigation.useNavigation)();
  var _useParams = (0, _reactRouterDom.useParams)(),
    roomId = _useParams.roomId,
    role = _useParams.role;
  var _useUserPreferences = (0, _useUserPreferences3.useUserPreferences)(_useUserPreferences3.UserPreferencesKeys.PREVIEW, _useUserPreferences3.defaultPreviewPreference),
    _useUserPreferences2 = _slicedToArray(_useUserPreferences, 1),
    previewPreference = _useUserPreferences2[0];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    direction: "column",
    css: {
      size: "100%"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        h: "$18",
        "@md": {
          h: "$17"
        }
      },
      "data-testid": "header",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
        isPreview: true
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      justify: "center",
      direction: "column",
      align: "center",
      css: {
        bg: "$mainBg",
        flex: "1 1 0",
        position: "relative"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "h2",
        css: {
          fontWeight: "$semiBold"
        },
        children: "\uD83D\uDC4B"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "h4",
        css: {
          color: "$textHighEmp",
          fontWeight: "$semiBold",
          mt: "$12"
        },
        children: "You left the room"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
        variant: "body1",
        css: {
          color: "$textMedEmp",
          mt: "$8",
          fontWeight: "$regular",
          textAlign: "center"
        },
        children: ["Have a nice day", previewPreference.name && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
          as: "span",
          css: _objectSpread({}, (0, _reactUi.textEllipsis)(100)),
          children: [", ", previewPreference.name]
        }), "!"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        css: {
          mt: "$14",
          gap: "$10",
          alignItems: "center"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "body1",
          css: {
            color: "$textMedEmp",
            fontWeight: "$regular"
          },
          children: "Left by mistake?"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
          onClick: function onClick() {
            var previewUrl = "/preview/" + roomId;
            if (role) previewUrl += "/" + role;
            navigate(previewUrl);
            _ToastManager.ToastManager.clearAllToast();
          },
          "data-testid": "join_again_btn",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ExitIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            css: {
              ml: "$3",
              fontWeight: "$semiBold",
              color: "inherit"
            },
            children: "Rejoin"
          })]
        })]
      })]
    })]
  });
};
var _default = PostLeave;
exports["default"] = _default;